/*
 * Home Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */

import { CHANGE_EMAIL, CHANGE_PASSWORD, LOGIN, LOGIN_FAILURE, LOGIN_SUCCESS, LOGOUT, CHANGE_LOADING, RESEND_EMAIL_VERIFICATION_CODE, CHANGE_SMSCODE, LOGIN_SMSCODE_REQUIRED } from './constants';

/**
 * Changes the input field of the form
 *
 * @param  {email} email The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_EMAIL
 */
export function changeEmail(email) {
  return {
    type: CHANGE_EMAIL,
    email,
  };
}

export function changePassword(password) {
  return {
    type: CHANGE_PASSWORD,
    password,
  };
}

export function changeSMSCode(smscode) {
  return {
    type: CHANGE_SMSCODE,
    smscode,
  };
}

export function login(mode, history) {
  return {
    type: LOGIN,
    mode,
    history,
  };
}

export function loginError(errors) {
  return {
    type: LOGIN_FAILURE,
    errors,
  };
}

export function loginSuccess() {
  return {
    type: LOGIN_SUCCESS,
  };
}

export function loginSMSCodeRequired() {
  return {
    type: LOGIN_SMSCODE_REQUIRED,
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function changeLoading(value) {
  return {
    type: CHANGE_LOADING,
    value,
  };
}

export function resendEmailVerificationCodeMail(history, email) {
  return {
    type: RESEND_EMAIL_VERIFICATION_CODE,
    history,
    email,
  };
}